const routes = [
    {
        name: 'listarPlanoDeContasContabilidade',
        path: '/contabilidade/categorias_movimentacoes_financeiras',
        alias: '/contabilidade/categorias_movimentacoes_financeiras/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarPlanoDeContaContabilidade',
        path: '/contabilidade/categorias_movimentacoes_financeiras/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarPlanoDeContaContabilidade',
        path: '/contabilidade/categorias_movimentacoes_financeiras/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarPlanoDeContaContabilidade',
        path: '/contabilidade/categorias_movimentacoes_financeiras/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
